<template>
  <div id="support-price" class="pa-7">
    <!--タイトル-->
    <span class="subHead">
      {{ title }}
    </span>
    <v-icon class="mb-2" color="blue-grey darken-2">
      {{ icon }}
    </v-icon>
    <!--以下for文で回す-->
    <div
    class="pa-5"
    v-for="(item, i) in contents"
    :key="i">
      <!--タイトル-->
      <div
      class="head2">
        {{ item.title }}
      </div>
      <!--データテーブル-->
      <div v-if="item.hasDataTable">
        <v-simple-table class="my-3">
          <thead>
            <tr>
              <!--データテーブルヘッダ-->
              <th
              v-for="(table, i) in item.tableHead"
              :key="i">
              {{ table.head }}
              </th>
            </tr>
          </thead>
          <tbody>
            <!--データテーブル内容-->
            <tr
            v-for="(table, i) in item.tableData"
            :key="i">
              <td>{{ table.item }}</td>
              <td>{{ table.price }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>
      <!--説明文-->
      <div
      v-for="(list, i) in item.content"
      :key="i">
        {{ list.description }}
      </div>
      <!--ボタン-->
      <v-btn
      rounded
      v-if="item.hasButton"
      color="primary"
      class="mt-4"
      :to="item.href">
        <!--ボタンの文字-->
        {{ item.button }}
        <v-icon>
          mdi-gesture-tap-hold
        </v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      title: '料金',
      icon: 'mdi-currency-usd',
      // 内容
      contents: [
        {
          // タイトル
          title: 'UMINのサーバーを利用し、デザインはポスターを利用する場合',
          // データテーブルを持つかどうか
          hasDataTable: 'true',
          // テーブルヘッダ
          tableHead: [
            {
              head: '項目'
            },
            {
              head: '料金'
            }
          ],
          // テーブルデータ
          tableData: [
            {
              item: 'デザイン作成費用',
              price: '30,000円'
            },
            {
              item: 'ページ作成費用 8頁',
              price: '24,000円 ( =3,000円x8頁 )'
            },
            {
              item: '更新サポート費用 8月',
              price: '24,000円 ( =3,000円x8カ月 )'
            },
            {
              item: 'UMIN申請費用',
              price: 'サービス'
            },
            {
              item: '',
              price: '78,000円 ( 合計 )'
            }
          ],
          // 説明文
          content: [
            // {
            //   description: '※1. 弊社のご用意したサーバーを利用する場合は、利用されるドメインの種類によって費用が異なりますのでお問合せお願いいたします。ドメイン費用を除いて1000円/月程度になります。'
            // },
            {
              description: '※ポスターが利用できない場合はお問合せお願いいたします。'
            }
          ]
        },
        {
          // タイトル
          title: '事前参加登録システム',
          // データテーブルを持つかどうか
          hasDataTable: 'false',
          // 説明文
          content: [
            {
              description: '5,000円/月'
            },
            {
              description: '※1. クレジット決済のみの場合は、上記月額よりも低コストでの運用をご案内いたします。'
            },
            {
              description: '※2. 会員、非会員のシステム上での確認が必要な場合は、別途費用が必要です。詳細はお問い合わせお願いいたします。'
            }
          ],
          // ボタンを持つかどうか
          hasButton: 'true',
          // ボタンの文字
          button: '詳しくはこちら',
          href: '/Products/participation'
        },
        {
          // タイトル
          title: 'UMINのオンライン学術集会演題抄録登録システムを利用する場合',
          // データテーブルを持つかどうか
          hasDataTable: 'false',
          // 説明文
          content: [
            {
              description: '5,000円/月'
            }
          ]
        },
        {
          // タイトル
          title: 'オンライン演題登録/査読システム',
          // データテーブルを持つかどうか
          hasDataTable: 'false',
          // 説明文
          content: [
            {
              description: '200演題程度'
            },
            {
              description: '50,000円/月 (弊社がご用意したSSL証明書料金含む)'
            },
            {
              description: '※登録される演題数によって異なりますので、お問合せお願いいたします。'
            }
          ],
          // ボタンを持つかどうか
          hasButton: 'true',
          // ボタンの文字
          button: '詳しくはこちら',
          href: '/Products/registration'
        }
      ]
    }
  }
}
</script>>
